let previousDataSrc = '';
let previousDataUrl = '';
let previousDataBadge = '';
let clickedDataSrc = '';
let clickedDataUrl = '';
let clickedDataBadge = '';

function handleImageHover(event) {
  const { dataSrc, dataUrl, dataBadge } = getImageAttributes(event);

  // Store the current image state before changing it
  const cardInner = event.target.closest('.card');
  const media = cardInner.querySelector('img');
  previousDataSrc = media.src;
  previousDataUrl = cardInner.querySelector('a').href;
  const previousBadge = cardInner.querySelector('.badge.badge--product');
  if (previousBadge) {
    previousDataBadge = previousBadge.textContent;
  }
  // Update the image temporarily if not clicked
  if (dataSrc && dataUrl) {
    updateCardMedia(event, dataSrc, dataUrl, dataBadge);
    //setActiveClass(event.target);
  }
}

function handleImageClick(event) {
  const { dataSrc, dataUrl, dataBadge } = getImageAttributes(event);
  if (dataSrc && dataUrl) {
    // Update the image permanently
    updateCardMedia(event, dataSrc, dataUrl, dataBadge);

    // Set the clicked state
    clickedDataSrc = dataSrc;
    clickedDataUrl = dataUrl;
    clickedDataBadge = dataBadge;
  }

  // Access the <li> element, not the <img>
  const liElement = event.target.closest('.variant-image');
  setActiveClass(liElement);

  // Clear the previous state since the click should set the new permanent state
  previousDataSrc = '';
  previousDataUrl = '';
  previousDataBadge = '';
}

function handleImageMouseOut(event) {
  // Revert the image to the previous state when mouse leaves, if not clicked
  if (previousDataSrc && previousDataUrl) {
    const cardInner = event.target.closest('.card');
    const media = cardInner.querySelector('img');
    const badge = cardInner.querySelector('.badge.badge--product');

    // Only revert if there's no clicked state
    if (media.src !== clickedDataSrc) {
      media.src = previousDataSrc;
      cardInner.querySelector('a').href = previousDataUrl;
      if (badge) {
        badge.textContent = previousDataBadge;
      }
    }
  }

  // Remove the hover active class if not clicked
  const liElement = event.target.closest('.variant-image');
  if (!liElement.classList.contains('active')) {
    liElement.classList.remove('active');
  }
}

function setActiveClass(targetElement) {
  const siblings = targetElement.parentElement.children;
  for (let sibling of siblings) {
    if (sibling !== targetElement) {
      sibling.classList.remove('active');
    }
  }
  targetElement.classList.add('active');
}

function getImageAttributes(event) {
  const img = event.target.querySelector('img');
  return img
    ? {
        dataSrc: img.getAttribute('data-src'),
        dataUrl: img.getAttribute('data-url'),
        dataBadge: img.getAttribute('data-badge'),
      }
    : {};
}

function updateCardMedia(event, dataSrc, dataUrl, dataBadge) {
  const cardInner = event.target.closest('.card');
  const anchor = cardInner.querySelector('a');
  const media = cardInner.querySelector('img');
  const badge = cardInner.querySelector('.badge.badge--product');
  media.src = dataSrc;
  anchor.href = dataUrl;
  if (badge) {
    badge.textContent = dataBadge;
  }
}

function initializeVariantImageEvents() {
  const variantImages = document.querySelectorAll('.variant-image');
  variantImages.forEach(function (image) {
    image.addEventListener('mouseenter', handleImageHover);
    image.addEventListener('mouseleave', handleImageMouseOut);
    image.addEventListener('click', handleImageClick);
  });

  // Find the active variant-image and trigger a click event
  const activeVariantImages = document.querySelectorAll('.variant-image.active');
  activeVariantImages.forEach(function (activeVariantImage) {
    if (activeVariantImage) {
      activeVariantImage.click();
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  getCollectionItemsCount();
  initializeVariantImageEvents();
  /* Making functions globally accessible for DY slider */
  window.handleImageHover = handleImageHover;
  window.handleImageClick = handleImageClick;
  window.getCollectionItemsCount = getCollectionItemsCount;
});

function ajaxinateCallBack() {
  initializeVariantImageEvents();
  var productList = document.getElementById('product-grid');
  var encounteredItems = new Map();
  var directChildren = productList.children;
  for (var i = directChildren.length - 1; i >= 0; i--) {
    var item = directChildren[i];
    var itemId = item.getAttribute('id');
    if (itemId) {
      if (encounteredItems.has(itemId)) {
        var previousItem = encounteredItems.get(itemId);
        previousItem.parentNode.removeChild(previousItem);
      }
      encounteredItems.set(itemId, item);
    }
  }

  const itemCount = encounteredItems.size;

  var countParagraph = document.getElementById('load-more__items-count');
  if (countParagraph) {
    countParagraph.textContent = countParagraph.textContent.replace(/\d+/, itemCount);
  }
}

function getCollectionItemsCount() {
  if (!window.collection_handle) {
    return;
  }
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const newUrl = `/collections/${collection_handle}?view=products-count&${searchParams.toString()}`;

  // Perform the fetch request
  fetch(newUrl)
    .then((response) => response.text())
    .then((text) => {
      const lines = text.split('\n').filter((line) => line.trim().length > 0);
      const itemCount = lines.join('\n');

      var countParagraphTop = document.getElementById('ProductCount');
      countParagraphTop.textContent = countParagraphTop.textContent.replace(/\d+/g, itemCount);
      countParagraphTop.style.display = 'block';
      var countParagraphNav = document.getElementById('load-more__items-count');
      if (countParagraphNav) {
        let occurrenceCount = 0;
        countParagraphNav.textContent = countParagraphNav.textContent.replace(/\d+/g, (match) => {
          occurrenceCount++;
          return occurrenceCount === 2 ? itemCount : match;
        });
      }
    })
    .catch((error) => console.error('Error fetching item count:', error));
}

function customBuildRedirect(productURL) {
  var current_url = productURL;
  if (!current_url.includes('?view=custom-watches')) {
    window.location.href = current_url + (current_url.includes('?') ? '&' : '?') + 'view=custom-watches';
  }
}

function facetsApplied() {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  return url.searchParams.toString().length > 0;
}
